import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function initSwiper() {
  const section = document.querySelector('.section-3');
  const itemsWrapper = document.querySelector('.section-3-items-wrapper');
  if (!section || !itemsWrapper) return;

  const items = Array.from(itemsWrapper.querySelectorAll('.section-3-item'));
  if (items.length <= 1) return;

  // Set initial stacked layout for all items
  items.forEach((item, index) => {
    gsap.set(item, {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: (index + 1) * 10,
      yPercent: index === 0 ? 0 : 100,
      opacity: index === 0 ? 1 : 0,
      scale: 1
    });

    const img = item.querySelector('.section-3-img');
    if (img && index > 0) {
      gsap.set(img, { scale: 1.15 });
    }
  });

  const isMobile = window.innerWidth <= 767;

  // Pin section-3 and scrub timeline continuously with Lenis
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: 'top top',
      end: () => isMobile ? '+=1600' : `+=${Math.max(4200, window.innerHeight * 4.5)}`, // Scale scroll distance for 2560x1440 and high-res viewports
      pin: true,
      pinSpacing: true,
      scrub: isMobile ? 0.3 : 0.6,
      anticipatePin: 1,
      invalidateOnRefresh: true,
      snap: {
        snapTo: 'labels', // Snap to each resting card label when scrolling stops
        duration: { min: 0.15, max: 0.35 },
        delay: 0.02,
        ease: 'power2.inOut'
      }
    }
  });

  // Card 1 initial resting state
  tl.addLabel('card-0');
  tl.to({}, { duration: isMobile ? 0.2 : 0.6 }); // Hold Card 1 completely visible

  // Build transitions + resting holds for each item
  for (let i = 0; i < items.length - 1; i++) {
    const currentItem = items[i];
    const nextItem = items[i + 1];
    const nextImg = nextItem.querySelector('.section-3-img');
    const nextTitle = nextItem.querySelector('.section-3-title');
    const nextDesc = nextItem.querySelector('.section-3-desc');

    // 1. Slowly fade out & scale slightly up/out the previous item so it vanishes cleanly (no clutter)
    tl.to(currentItem, {
      opacity: 0,
      scale: 0.95,
      yPercent: -4,
      ease: 'none',
      duration: 1
    });

    // 2. Incoming card fades in & slides UP cleanly
    tl.fromTo(nextItem,
      { yPercent: 100, opacity: 0 },
      { yPercent: 0, opacity: 1, ease: 'none', duration: 1 },
      '<'
    );

    // 3. Parallax image scale zoom out
    if (nextImg) {
      tl.to(nextImg, {
        scale: 1,
        ease: 'none',
        duration: 1
      }, '<');
    }

    // 4. Typography stagger reveal
    if (nextTitle) {
      tl.fromTo(nextTitle,
        { y: 24, opacity: 0 },
        { y: 0, opacity: 1, ease: 'none', duration: 0.7 },
        '<+=0.2'
      );
    }
    if (nextDesc) {
      tl.fromTo(nextDesc,
        { y: 20, opacity: 0 },
        { y: 0, opacity: 1, ease: 'none', duration: 0.7 },
        '<+=0.3'
      );
    }

    // Add label when incoming card becomes COMPLETELY VISIBLE
    tl.addLabel(`card-${i + 1}`);

    // Hold duration: Wait till card is completely visible before starting next item
    tl.to({}, { duration: isMobile ? 0.2 : 0.8 });
  }

  console.log('Section 3 clean fade-out card transitions initialized.');
}
